import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { parseMailSearch } from '../features/mail/route';
import { Route as RootRoute } from './__root';

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/mail',
  validateSearch: parseMailSearch,
  component: lazyRouteComponent(() => import('../pages/mail'), 'MailPage'),
});
